import axios from 'axios';
import { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './MyWork.css';
import NavBarShan from '../NavBar/NavBar';
import LoadingLoggedIn from '../Loading/Loading';

class MyWorkDet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closeClassName: 'far fa-times-circle',
      myWorkProjectData: [],
      myWorkProjectDataUrl: 'https://my-webpage-node.vercel.app/MyWork/',
      Loading: false,
      line1: 'My Work',
      textAnimationLine1: [],
      editPopUp: false,
      editPopUpData: {}
    }
  }

  async componentDidMount() {
    let tempArr1 = []
    this.props.SelectedPage('LoggedInPage', {
      SelectedPage: 3
    })
    if (this.state.textAnimationLine1.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
      }
    }
    this.setState({
      textAnimationLine1: tempArr1,
      editPopUpData: {}
    })
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40 && this.state.Loading) {
        let arr1 = this.state.textAnimationLine1;
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        }
      }
    }, 100);
    if (this.props.localStorageData.NavBarLoginText.Login === false) {
      this.props.history.push('/Login');
    }
    await axios.get(this.state.myWorkProjectDataUrl).then((data) => {
      this.setState({
        myWorkProjectData: data.data,
        Loading: true
      })
    }).catch((e) => {
      console.log(e);
      this.setState({
        Loading: false
      })
    })
  }

  render() {
    if (this.props.localStorageData.NavBarLoginText.Login === false) {
      this.props.history.push('/Login');
    }
    return (<>
      <div className='LoggedInCommonDiv'>
        <NavBarShan />
        {this.state.Loading ?
          <div className='LoggedInSideDiv'>
            <div className='MyWorkHeadingDiv'>
              {this.state.line1.split('').map((ite, index) => {
                return (<>{ite === ' ' ? <span className='MyWorkAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                  let ani = this.state.textAnimationLine1
                  ani[index] = { letterAni: 1 }
                  this.setState({
                    textAnimationLine1: ani
                  })
                }} onMouseLeave={() => {
                  setTimeout(() => {
                    let ani = this.state.textAnimationLine1
                    ani[index] = { letterAni: 2 }
                    this.setState({
                      textAnimationLine1: ani
                    })
                  }, 500)
                }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'MyWorkAniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'MyWorkAniLetterMouse MyWorkAniLetter' : 'MyWorkAniLetter'}>{ite}</span>}
                </>)
              })}
            </div>
            <table className='MyWorkLoggedInTbl'>
              <thead>
                <tr>
                  <th className='MyWorkpd20 MyWorkLoggedInTblBrd'>ID No</th>
                  <th className='MyWorkpd20 MyWorkLoggedInTblBrd'>Role Description</th>
                  <th className='MyWorkpd20 MyWorkLoggedInTblBrd'>Option</th>
                </tr>
              </thead>
              <tbody>
                {/* {this.state.MyWorkData.map((ite, index) => {
                                    return (<>
                                        <tr>
                                            <td className='MyWorkpd20 MyWorkLoggedInTblBrd'>{ite?._id}</td>
                                            <td className='MyWorkpd20 MyWorkLoggedInTblBrd'>{ite?.role}</td>
                                            <td className='MyWorkpd20 MyWorkEditBtn MyWorkLoggedInTblBrd' onClick={() => {
                                                this.setState({
                                                    editPopUpData: ite,
                                                    editPopUp: true
                                                })
                                            }}>Edit</td>
                                        </tr>
                                    </>)
                                })} */}
              </tbody>
            </table>
          </div> :
          <LoadingLoggedIn />}
        {this.state.editPopUp ?
          <div className='MyWorkEditDataPopUpLoggedIn'>
          </div>
          : ''}
      </div>

    </>);
  }
}

const mapStateToProps = (state) => ({
  localStorageData: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoadingPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyWorkDet));